<template>
    <div style="width:100% height:100%">
           <el-container>
                <el-header>
                    <my-nav></my-nav>
                </el-header>
                <el-main>
                     <router-view></router-view>
                </el-main>
           </el-container>
        
    </div>
</template>

<script>
import myNav from '../../components/nav.vue'
    export default {
        components: {
            myNav,
        },
        data() {
            return {
               
            }
        },
        created() {
          let data = sessionStorage.getItem("userInfo")
          
        },
        mounted() {
          
        },
        props: {},
        watch: {
           
        },
        computed: {}
        
    };
</script>
<style lang="scss" scoped>
  .el-header {
    color: #333;
    text-align: center;
    line-height: 60px;
    padding: 0;
  }
 ::v-deep .el-main {
    padding: 0;
    height: 100%;
    overflow: auto !important;
  }
  
   
 
  
  
</style>